module.exports = __webpack_public_path__ + "./images/foiling.jpg?3e4703d3e16523af669f628260f64982";


//////////////////
// WEBPACK FOOTER
// ./src/assets/foiling.jpg
// module id = 41
// module chunks = 0